import { render } from "./QRPicto.vue?vue&type=template&id=fe8c5baa"
import script from "./QRPicto.vue?vue&type=script&lang=js"
export * from "./QRPicto.vue?vue&type=script&lang=js"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__